"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "poviglio": {
    "1ec09c14": [{
      "hkey": "52c5e088",
      "slug": "poviglio",
      "name": "Poviglio",
      "primary": true,
      "skipSearch": false
    }],
    "enzola": [{
      "hkey": "52c5e088",
      "slug": "poviglio",
      "name": "Poviglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "38e5df05": [{
      "hkey": "52c5e088",
      "slug": "poviglio",
      "name": "Poviglio",
      "primary": true,
      "skipSearch": false
    }],
    "la-noce": [{
      "hkey": "52c5e088",
      "slug": "poviglio",
      "name": "Poviglio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bf521305": [{
      "hkey": "4411a25e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "sant-anna": [{
      "hkey": "4411a25e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "poviglio"
    }]
  }
};
exports["default"] = _default;